import React, { createContext, useContext, useEffect, useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import Modal from '../Components/Modal';
import Button from '../Components/Button'
import {UserContext} from './UserContext'
  

const IdleTimerContext = createContext();
const DEFAULT_IDLE_TIMEOUT_MINUTES = 60;
// Warning ~20 minutes into a 60-minute idle window (40 minutes before logout).
const DEFAULT_IDLE_WARNING_MINUTES = 40;
const ONE_MINUTE_MS = 60 * 1000;
const getEnvMinutes = (value, fallback) => {
  const minutes = Number(value);
  return Number.isFinite(minutes) && minutes > 0 ? minutes : fallback;
};
const IDLE_TIMEOUT = 1000 * 60 * getEnvMinutes(process.env.REACT_APP_IDLE_LOGOUT_MINUTES, DEFAULT_IDLE_TIMEOUT_MINUTES);
const IDLE_WARNING_TIME = 1000 * 60 * getEnvMinutes(process.env.REACT_APP_IDLE_WARNING_MINUTES, DEFAULT_IDLE_WARNING_MINUTES);

const formatTimeRemaining = (ms) => {
  if (ms > ONE_MINUTE_MS) {
    const minutes = Math.ceil(ms / ONE_MINUTE_MS);
    return `${minutes} ${minutes === 1 ? 'minute' : 'minutes'}`;
  }
  const seconds = Math.max(0, Math.ceil(ms / 1000));
  return `${seconds} ${seconds === 1 ? 'second' : 'seconds'}`;
};

export const useIdleTime = () => {
  const context = useContext(IdleTimerContext);
  if (!context) {
    throw new Error('use idletimer issue');
  }
  return context;
};

export const IdleTimerProvider = ({ 
  children,
  timeout = IDLE_TIMEOUT,
  warningTime = IDLE_WARNING_TIME,
}) => {
  const [isWarning, setIsWarning] = useState(false);
  const [timeRemaining, setTimeRemaining] = useState(timeout);
  const [showModal, setShowModal] = useState(false);
  const { user, signOut } = useContext(UserContext);
  const excludedPaths = ['/', '/login', '/resetPassword', '/resetUserPassword']

  const onIdle = () => {
    setShowModal(false);
    setIsWarning(false);
    if(user) {
       handleLogout();
    }   
  };

  const onActive = () => {
    setIsWarning(false);
    setShowModal(false);
  };

  const onPrompt = () => {
    if(!isExcludedPath) {   
      setIsWarning(true);
      setShowModal(true);  
    }
  };


  const { activate, deactivate, reset, getRemainingTime } = useIdleTimer({
    timeout,
    onIdle,
    onActive,
    onPrompt,
    promptBeforeIdle: warningTime,
    crossTab: {
      emitOnAllTabs: true,
    },
    syncTimers: 200
  });

  const isExcludedPath = excludedPaths.includes(location.pathname)


  useEffect(() => {
     //if(user && user.accountType != ''){
      const interval = setInterval(() => {
        setTimeRemaining(getRemainingTime());
      }, 1000);

      return () => {
        clearInterval(interval);
      };
    //}
  }, [getRemainingTime]);

  const handleStayActive = () => {
    reset();
    setIsWarning(false);
    setShowModal(false);
  };

  const handleLogout = () => {
    setIsWarning(false);
    setShowModal(false);
    signOut();
    //TODO verify login url
    window.location.href = "/"
  };

  const value = {
    isWarning,
    timeRemaining,
    showModal,
    onStayActive: handleStayActive,
    onLogout: handleLogout,
    activate,
    deactivate,
    reset
  };

  return (
    <IdleTimerContext.Provider value={value}>
      {children}
      <Modal isOpen={showModal}>
        <Modal.Header>Still connected?</Modal.Header>
        <Modal.Body>
          Time remaining: {formatTimeRemaining(timeRemaining)}
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleStayActive}>Continue</Button>
          <Button className="ms-2" onClick={handleLogout}>Logout</Button>           
        </Modal.Footer>
      </Modal>
    </IdleTimerContext.Provider>
  );
};